(() => {

  const makeCartUpsellsVertical = () => {
    const recommendations = document.querySelector('.cart-drawer__recommendations')
    if (!recommendations) return
    const prevButton = recommendations.querySelector('[is="prev-button"]')
    const nextButton = recommendations.querySelector('[is="next-button"]')
    const carousel = recommendations.querySelector('scroll-carousel')
    const list = carousel.querySelector('.horizontal-product-list')
    if (!list) return
    list.classList.remove('horizontal-product-list', 'divide-x')
    list.classList.add('divide-y')
    prevButton.style.display = 'none';
    nextButton.style.display = 'none';
    list.querySelectorAll('.horizontal-product').forEach(el => {
      el.classList.remove('rounded-xs')
    });
  }

  const showFreeShippingUKOnly = () => {
    if (window.Shopify.country === 'GB') {
      document.querySelectorAll('free-shipping-bar').forEach(el => {
        el.style.display = 'block';
      });
    }
  }

  window.Exh = window.Exh || {};

  window.Exh.formatMoney = (cents, format = "") => {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.themeVariables.settings.moneyFormat;
    function defaultTo(value2, defaultValue) {
      return value2 == null || value2 !== value2 ? defaultValue : value2;
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ",");
      decimal = defaultTo(decimal, ".");
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100).toFixed(precision);
      let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
      return dollarsAmount + centsAmount;
    }
    let value = "";
    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_space_separator":
        value = formatWithDelimiters(cents, 2, " ", ".");
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'", ".");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
      case "amount_no_decimals_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 0, "'");
        break;
    }
    if (formatString.indexOf("with_comma_separator") !== -1) {
      return formatString.replace(placeholderRegex, value);
    } else {
      return formatString.replace(placeholderRegex, value);
    }
  }

  window.Exh.shopifyImgUrl = (src, size) => {
    return src.replace(/(\.[^.]*)$/, size + '$1')
  }

  const initOnLoad = () => {
    showFreeShippingUKOnly();
    makeCartUpsellsVertical();
  }

  const handleCartChange = () => {
    showFreeShippingUKOnly();
    makeCartUpsellsVertical();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initOnLoad();
    });
  } else {
    initOnLoad();
  }

  window.addEventListener('cart:change', handleCartChange);
  window.addEventListener('cart:refresh', handleCartChange);
  window.addEventListener('line-item:change', handleCartChange);

})();
